
import {
    FETCH_LEADERSHIP_ANALYTIC_REQUEST,
    FETCH_LEADERSHIP_ANALYTIC_SUCCESS,
    FETCH_LEADERSHIP_ANALYTIC_FAILURE
} from '../../../../../Constants/actionTypes';

const initialState = {
    loading: false,
    result: {},
    error: null,
};

const leadershipAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LEADERSHIP_ANALYTIC_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_LEADERSHIP_ANALYTIC_SUCCESS:
            const { filter, data } = action.payload; // Expect filter to be included in payload
            return {
                ...state,
                loading: false,
                result: {
                    ...state.result,
                    [filter]: data // Store data for the specific range
                }
            };
        case FETCH_LEADERSHIP_ANALYTIC_FAILURE:
            console.log("Reducer received error payload:", action.payload); // Debug log
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default leadershipAnalyticsReducer;
